import { createContext, useContext } from 'react';

import { TrackingContextValue } from '../types/contexts';

// ============================================================================
// Tracking Context
// ============================================================================
// Context for tracking analytics events (Google Analytics, etc.)

declare global {
    function gtag(command: string, ...args: unknown[]): void;
}

export const tracker: TrackingContextValue = {
    trackEvent: (event: string, properties?: Record<string, unknown>) => {
        if (typeof gtag !== 'undefined') {
            gtag('event', event, properties);
        }
    },

    trackPage: (path: string, properties?: Record<string, unknown>) => {
        if (typeof gtag !== 'undefined') {
            gtag('config', 'GA_MEASUREMENT_ID', {
                page_path: path,
                ...properties,
            });
        }
    },
};

const TrackingContext = createContext<TrackingContextValue>(tracker);

// Hook to use tracking context
export function useTracking(): TrackingContextValue {
    return useContext(TrackingContext);
}

export default TrackingContext;
